import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: ${theme.fonts.main};
  background: ${theme.colors.background};
`;

export const Hero = styled.div`
  position: relative;
  background: url('${props => props.bg}') center/cover no-repeat;
  color: ${theme.colors.secondary};
  padding: 4rem;
  text-align: center;
  border-radius: 8px;
  min-height: 540px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(20, 20, 20, 0.65); // 深灰半透明
    z-index: 1;
    border-radius: 8px;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
`;

export const HeroLogo = styled.img`
  height: 100px;
  width: auto;
  margin-bottom: 1rem;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    height: 60px;
    padding: 10px 16px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  min-width: 160px;
  
  ${props => {
    switch (props.variant) {
      case 'outline':
        return `
          background: transparent;
          color: white;
          border: 2px solid white;
          
          &:hover {
            background: white;
            color: #3949ab;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
        `;
      case 'primary':
        return `
          background: #3949ab;
          color: white;
          border: 2px solid #3949ab;
          
          &:hover {
            background: #303f9f;
            border-color: #303f9f;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(57, 73, 171, 0.3);
          }
        `;
      default:
        return `
          background: rgba(255, 255, 255, 0.9);
          color: #3949ab;
          border: 2px solid rgba(255, 255, 255, 0.9);
          
          &:hover {
            background: white;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
        `;
    }
  }}
  
  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 0.9rem;
    min-width: 140px;
  }
`;

export const Announcement = styled.div`
  margin-top: 2rem;
`;

export const Section = styled.section`
  margin: 2.5rem 0;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
`;

export const Highlight = styled.div`
  color: #ff9900;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  margin: 0.5rem 0;
`;

export const BannerImage = styled.img`
  width: 80%; // 减小横幅图片宽度
  max-width: 80%;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin: 0 auto 1.2rem auto; // 居中显示
  display: block;
  object-fit: cover;
  marginTop: 1rem;
`;

export const VideoContainer = styled.div`
  width: 100%;
  margin: 2rem 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
`;

export const Video = styled.video`
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  background: #000;
`;


export const LargeBannerImage = styled.img`
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin: 0 auto 1.2rem auto;
  display: block;
  object-fit: contain; // 改为contain以完整显示图片
  min-height: 200px; // 减小最小高度，适配移动端
  
  @media (max-width: 768px) {
    object-fit: contain; // 移动端确保完整显示
    min-height: 150px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    min-height: 120px;
    border-radius: 4px;
  }
`;

/* ---- Hero Motto & Vision ---- */

export const HeroMotto = styled.h2`
  font-size: 2.4rem;
  font-weight: 800;
  letter-spacing: 0.22em;
  margin: 0.5rem 0 0.5rem;
  line-height: 1.5;
  color: ${theme.colors.primary};
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);

  @media (max-width: 768px) {
    font-size: 1.5rem;
    letter-spacing: 0.14em;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    letter-spacing: 0.08em;
  }
`;

export const HeroMottoZh = styled.p`
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.35em;
  margin: 0 0 1.8rem;
  color: #fff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);

  @media (max-width: 768px) {
    font-size: 1.1rem;
    letter-spacing: 0.2em;
  }
`;

export const HeroVisionLabel = styled.span`
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  background: ${theme.colors.primary};
  color: #fff;
  padding: 5px 22px;
  border-radius: 20px;
  margin-bottom: 1rem;
`;

export const HeroVision = styled.p`
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.8;
  max-width: 740px;
  margin: 0 auto 0.5rem;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const HeroVisionZh = styled.p`
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.8;
  max-width: 740px;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }
`;

/* ---- Student Achievements Section ---- */

export const AchievementCard = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 3rem 3.5rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  width: 100%;
  margin-top: 2rem;

  @media (max-width: 600px) {
    padding: 2rem 1.5rem;
    border-radius: 12px;
  }
`;

export const AchievementToggle = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${theme.colors.primary};
    color: #fff;
    border-color: ${theme.colors.primary};
  }
`;

export const AchievementTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.4rem;
  line-height: 1.4;
  padding-right: 80px;

  @media (max-width: 600px) {
    font-size: 1.25rem;
    padding-right: 70px;
  }
`;

export const AchievementSubtitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  color: ${theme.colors.primary};
  margin: 0;
  line-height: 1.5;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const AchievementDivider = styled.hr`
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 1.5rem 0;
`;

export const AchievementList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const AchievementItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const AchievementBullet = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
  margin-top: 8px;
`;

export const AchievementText = styled.span`
  font-size: 1rem;
  line-height: 1.65;
  color: #374151;
`;

export const AchievementRed = styled.span`
  color: #ef4444;
  font-weight: 600;
`;

export const AchievementBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AchievementParagraph = styled.p`
  font-size: 1rem;
  line-height: 1.75;
  color: #4b5563;
  margin: 0;
`;

export const Quote = styled.blockquote`
  margin: 1.5rem auto;
  padding: 1rem 1.5rem;
  background: #f9f6f2;
  border-left: 4px solid #f5a623;
  font-style: italic;
  color: #333;
  max-width: 700px;
`;

export const Paragraph = styled.p`
  margin: 0.5rem 0;
  line-height: 1.7;
  color: #222;
`;